import { render, staticRenderFns } from "./section.submissions-review.vue?vue&type=template&id=c9979a4c&scoped=true&"
import script from "./section.submissions-review.vue?vue&type=script&lang=js&"
export * from "./section.submissions-review.vue?vue&type=script&lang=js&"
import style0 from "./section.submissions-review.vue?vue&type=style&index=0&id=c9979a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9979a4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
